import { useTranslation } from "react-i18next";
import ExpandableRow from "./ExpandableRow";

export const ClaimsRequest = ({ data, setOpenChatWindow, type }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="ui-card-bar relative mt-4">
        <div className="px-3 py-2 lg:p-4 ">
          <div className="grid grid-cols-1 md:grid-cols-6 gap-2 xl:gap-2">
            <div className="text-xs font-bold  text-theme-text-secondary md:col-span-3">
              {t("CustomerClaims-claimsrequest-claimtype")}
            </div>
            <div className="text-xs font-bold  text-theme-text-secondary md:col-span-1">
              {t("CustomerClaims-claimsrequest-policy")}
            </div>
            <div className="text-xs font-bold  text-theme-text-secondary md:col-span-1">
              {t("CustomerClaims-claimsrequest-claim")}
            </div>
            <div className="text-xs font-bold  text-theme-text-secondary md:col-span-1">
              {t("CustomerClaims-claimsrequest-date-recieved")}
            </div>
          </div>
        </div>
      </div>
      {data.map((item) => {
        return (
          <ExpandableRow
            key={item.taskID}
            data={item}
            setOpenChatWindow={setOpenChatWindow}
            type={type}
          />
        );
      })}
    </>
  );
};
